import React from 'react';
import { OpsCategory } from '../../types';
import { ClipboardList, Wrench, ShoppingCart, MessageSquare, MoreHorizontal, FolderOpen, Eye, EyeOff, Bot } from 'lucide-react';
import './OpsSidebar.css';

interface OpsSidebarProps {
  selectedCategory: OpsCategory | null;
  onSelectCategory: (cat: OpsCategory | null) => void;
  categoryCounts: Record<string, number>;
  onNewTask: () => void;
  hideCompleted: boolean;
  onToggleHideCompleted: () => void;
  showAgentTasksOnly: boolean;
  onToggleAgentTasksOnly: () => void;
  agentTaskCount: number;
}

const CATEGORIES: { id: OpsCategory | null; label: string; icon: React.ReactNode }[] = [
  { id: null, label: 'All Tasks', icon: <FolderOpen size={15} /> },
  { id: 'admin', label: 'Admin', icon: <ClipboardList size={15} /> },
  { id: 'maintenance', label: 'Maintenance', icon: <Wrench size={15} /> },
  { id: 'ordering', label: 'Ordering', icon: <ShoppingCart size={15} /> },
  { id: 'requests', label: 'Requests', icon: <MessageSquare size={15} /> },
  { id: 'other', label: 'Other', icon: <MoreHorizontal size={15} /> },
];

const OpsSidebar: React.FC<OpsSidebarProps> = ({
  selectedCategory,
  onSelectCategory,
  categoryCounts,
  onNewTask,
  hideCompleted,
  onToggleHideCompleted,
  showAgentTasksOnly,
  onToggleAgentTasksOnly,
  agentTaskCount,
}) => {
  return (
    <div className="ops-sidebar">
      <div className="ops-sidebar-header">
        <span className="ops-sidebar-label">Operations</span>
      </div>

      <nav className="ops-sidebar-nav">
        {CATEGORIES.map(cat => {
          const isActive = cat.id === selectedCategory;
          const count = cat.id === null ? categoryCounts.all : categoryCounts[cat.id] || 0;
          return (
            <button
              key={cat.id || 'all'}
              className={`ops-sidebar-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelectCategory(cat.id)}
            >
              <span className="ops-sidebar-item-icon">{cat.icon}</span>
              <span className="ops-sidebar-item-label">{cat.label}</span>
              {count > 0 && <span className="ops-sidebar-item-count">{count}</span>}
            </button>
          );
        })}
      </nav>

      <div className="ops-sidebar-divider" aria-hidden />

      <button
        type="button"
        className={`ops-sidebar-item ops-sidebar-item--filter ${showAgentTasksOnly ? 'active' : ''}`}
        onClick={onToggleAgentTasksOnly}
        title="Show tasks created by agents"
      >
        <span className="ops-sidebar-item-icon"><Bot size={15} /></span>
        <span className="ops-sidebar-item-label">Agent tasks</span>
        {agentTaskCount > 0 && <span className="ops-sidebar-item-count">{agentTaskCount}</span>}
      </button>

      <button
        className={`ops-sidebar-toggle-completed ${!hideCompleted ? 'showing' : ''}`}
        onClick={onToggleHideCompleted}
      >
        {hideCompleted ? <Eye size={13} /> : <EyeOff size={13} />}
        <span>{hideCompleted ? 'Show completed' : 'Hide completed'}</span>
      </button>
    </div>
  );
};

export default OpsSidebar;
